import { useAppSelector } from "store";
import { getUserSelector } from "store/user/user.selector";
import hydraAccountBlue from "data/icons/hydra-account-blue.svg";
import hydraAccount from "data/icons/hydra-account.svg";
import phoneIconGray from "data/icons/phone-gray.svg";
import emailIconGray from "data/icons/email-gray.svg";

interface IProps {
  contractor: any;
  authorName: string;
  authorPhoneNumber: string;
  authorEmail: string;
}

const CaseCustomerCard = ({
  contractor,
  authorName,
  authorPhoneNumber,
  authorEmail,
}: IProps) => {
  const { organization } = useAppSelector(getUserSelector);

  return (
    <div className="customer-card">
      <div className="customer-card-title">
        <img
          alt=""
          className="customer-card-title-icon"
          src={ contractor?.has_account ? hydraAccountBlue : hydraAccount }
        />

        { contractor?.official_name || organization?.official_name }
      </div>

      <div className="customer-card-title">
        { authorName }
      </div>

      <div>
        <img
          alt=""
          src={ phoneIconGray }
          style={ { marginRight: 5, marginBottom: -1 } }
        />

        <span>{ authorPhoneNumber }</span>
      </div>

      <div>
        <img
          alt=""
          src={ emailIconGray }
          style={ { marginRight: 5, marginBottom: -1 } }
        />

        <span>{ authorEmail }</span>
      </div>
    </div>
  );
};

export default CaseCustomerCard;
